/* eslint-disable */
import React, { useState } from 'react'
import Card from '../../components/card'
import BreadCrumb from '../../components/breadcrumb'
import { TextBodyOne } from '../../components/text'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { IoIosArrowDown } from 'react-icons/io'

import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'

import Badge from '../../components/badge'
import { JobListCard, Menu, JobListStyle } from './index.style'
import { dataJobDetail } from '../../translate/data-job-detail'
import dompurify from 'dompurify'


const JobList = () => {
  const [activeAccordionJob, setActiveAccordionJob] = useState(0)
  const sanitizer = dompurify.sanitize

  const clickJobListing = id => {
    setActiveAccordionJob(id)
  }

const data = dataJobDetail

  return (
    <JobListStyle>
      <Helmet>
        <title>List Lowongan Pekerjaan | halojasa.com</title>
        <meta charSet="utf-8" />
        <meta name="description" content="Ingin bergabung dan berkontribusi menciptakan kebermanfaatan bersama kami ? Cek lowongan kerja yang ada" />
        <meta property="og:title" content="Info Lowongan Pekerjaan | halojasa.com" />
        <meta property="og:site_name" content="Halo Jasa" />
        <meta property="og:url" content="https://halojasa.com/about/job-list/" />
        <meta property="og:description" content="Ingin bergabung dan berkontribusi menciptakan kebermanfaatan bersama kami ? Cek lowongan kerja yang ada" />
        <meta property="og:image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karir-ls.png" />
        <meta property="og:image:secure_url" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karir-ls.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image" itemProp="image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karis-sq.png" />
        <meta property="og:image:secure_url" itemProp="image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karis-sq.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="300" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="951866408583742" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@pthalojasa" />
        <meta name="twitter:title" content="Info Lowongan Pekerjaan | halojasa.com" />
        <meta name="twitter:description" content="Ingin bergabung dan berkontribusi menciptakan kebermanfaatan bersama kami ? Cek lowongan kerja yang ada" />
        <meta name="twitter:image:src" content="https://halojasa.com/blog/wp-content/uploads/2020/06/karir-ls.png" />
        <meta name="p:domain_verify" content="4e6fcb4deba1a02d84225fad69babc0b" />
        <meta name="keyword" content="lowongan kerja halo jasa" />
      </Helmet>
      <div style={{ paddingTop: 160 }} className="main-job-list-wrapper">
        <Grid>
          <Row>
            <Col lg={12} sm={12} md={12} xs={12}>
              <BreadCrumb
                options={[
                  {
                    name: 'Beranda',
                    link: '/'
                  },
                  {
                    name: 'Tentang Kami',
                    link: '/bantuan/tentang-kami'
                  },
                  {
                    name: 'Karir',
                    link: '/'
                  },
                  {
                    name: 'Job List',
                    link: false
                  }
                ]}
              ></BreadCrumb>
            </Col>
          </Row>
          <Row>
            <Col lg={12} sm={12} xs={12}>
              <Menu className="job-tag-wrapper">
                <button type="button" className="active">
                  All
                </button>
                <button type="button">Creative</button>
                <button type="button">Technology</button>
                <button type="button">Operational</button>
              </Menu>
            </Col>
          </Row>
          <Row>
            {data.map(item => (
              <Col
                key={item.id}
                lg={4}
                sm={6}
                xs={12}
                onClick={() => clickJobListing(item.id)}
              >
                <Card>
                  <JobListCard>
                    <div className="title">
                      {item.title}
                      <IoIosArrowDown
                        className={`${
                          activeAccordionJob === item.id
                            ? 'active-job-listing'
                            : ''
                          }`}
                      />
                    </div>

                    <div
                      className={`responsive-accordion ${
                        activeAccordionJob === item.id
                          ? 'active-responsive-accordion'
                          : ''
                        }`}
                    >
                      <div className="top">
                        <TextBodyOne>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: sanitizer(item.description.substring(0, 90) + '...')
                            }}
                          />
                        </TextBodyOne>
                        <div className="list-tag">
                          <Badge>
                            {/* <item.icon /> {item.tag} */}
                            <img src={item.icon} alt="" />
                            {item.tag}
                          </Badge>
                        </div>
                      </div>
                      <div className="bottom">
                        {/* <a
                          href={`/about/job-detail?id=${item.id}&title=${item.title}&description==${item.description}&requirement==${item.requirement}`}
                          className="apply-button smaller-hover"
                        > */}
                        <Link to={{
                          pathname: '/about/job-detail/' + item.url,
                          state: {
                            id: item.id,
                            title: item.title,
                            description: item.description,
                            requirement: item.requirement,
                            url: item.url
                          }
                        }}
                          className="apply-button smaller-hover"
                        >
                          APPLY
                        </Link>
                        {/* </a> */}
                        {/* <a
                          href={`/about/job-detail?id=${item.id}&title=${item.title}&description==${item.description}&requirement==${item.requirement}`}
                          className="detail-button smaller-hover"
                        > */}
                        <Link to={{
                          pathname: '/about/job-detail/' + item.url,
                          state: {
                            id: item.id,
                            title: item.title,
                            description: item.description,
                            requirement: item.requirement,
                            url: item.url
                          }
                        }}
                          className="detail-button smaller-hover"
                        >
                          SEE DETAILS
                        </Link>
                      </div>
                    </div>
                  </JobListCard>
                </Card>
              </Col>
            ))}
          </Row>
        </Grid>
      </div>
    </JobListStyle>
  )
}

export default JobList
